import { IProductDTO, ITeamLevelDTO } from '@/dtos';
import { get, post, remove } from '@/services/apiWrapper';

export const getAvailableProductTeamLevelsAPI = async (
  yearId: string,
): Promise<{ data: ITeamLevelDTO[]; count: number }> => {
  const admins = await get<{ data: ITeamLevelDTO[]; count: number }>(
    `/admin/products/year/${yearId}/available`,
  );
  return admins;
};

export const getProductsForYearAdminAPI = async (
  yearId: string,
): Promise<{ data: IProductDTO[]; count: number }> => {
  const admins = await get<{ data: IProductDTO[]; count: number }>(
    `/admin/products/year/${yearId}`,
  );
  return admins;
};

export const createProductAPI = async (yearId: string, body: IProductDTO): Promise<IProductDTO> => {
  const admins = await post<IProductDTO>(`/admin/products/year/${yearId}`, body);
  return admins;
};

export const saveProductAPI = async (product: IProductDTO): Promise<IProductDTO> => {
  const admins = await post<IProductDTO>(`/admin/product/${product.id}`, product);
  return admins;
};

export const deleteProductAPI = async (productId: string): Promise<void> => {
  await remove<void>(`/admin/product/${productId}`);
};
